<template>
  <article class="user_view">
    <left-menu/>
    <section class="new_user" >
      <div @click="$router.push({ name: 'Admins' })" class="back_button">
        <img src="./../../assets/img/icons/back-button.svg">
        <span>atrás</span>
      </div>
      <section class="new_user__form">
        <h1> Crear operario </h1>
        <div class="new_user__form--input-sec">
          <div class="form_input">
            <label>Nombre</label>
            <input v-model="user.name" placeholder="Nombre"/>
          </div>
          <div class="form_input">
            <label>Apellido</label>
            <input v-model="user.lastName" placeholder="Apellido"/>
          </div>
          <div class="form_input">
            <label>Número de cédula</label>
            <input v-model="user.cc" placeholder="Número de cédula"/>
          </div>
          <div class="form_input">
            <label>Correo electrónico</label>
            <input @input="checkMailAcepted" type ="email" v-model="user.email" placeholder="Correo electrónico"/>
          </div>
         
          <!-- <div class="form_input"> -->
            <!-- <label>Rol</label> -->
            <!---<div class="form_input--select">
              
            <span :style="{color:'#A8B1BF', 'margin-right': '5px'}">Administrador</span><input disabled type="checkbox" value = "true"/>
            </div>-->
            <!-- <div class="form_input--select" >              
              <input type="checkbox" v-model="user.role" value="false" :style="{color:'#A8B1BF', 'margin-right': '5px','margin-top': '5px'}" /> 
              <span :style="{ 'margin-top': '5px' }">Administrador</span>  -->
              <!--select v-model="user.role" placeholder="Seleccione">
                <option value="" :style="{color: '#A8B1BF'}" disabled selected>Seleccione</option>
                <option value="rol">Administrador</option>
                <option value="role">Administrador y Coordinador</option>
              </select>
              <!-- <img src="./../../assets/img/icons/arrow-down-sign-to-navigate.svg"-->
            <!-- </div>           
          </div> --> 
          <div class="form_input" v-if="!user.role">
              <label>Departamento</label>
              <select id="select1" style="color: #A8B1BF;" @focus="selectFocused()" @blur="selectBlur()" v-model="user.department">
                <option value="" disabled selected hidden >Departamento</option>
                <option v-for="(depto,index) in departamentos" :key="index" :value= depto >{{depto}}</option> 
              </select>
          </div>
        </div>
         <div style="margin-bottom:10px">
          <h5  class="login__sect-right__form--error">{{errorMessage}}</h5> 
        </div>
        <button class="secondary_button" :class="{'click':isCreated,'active': isComplete()}" @click.prevent="createAdministrator" :style="{width: '160px', height:'46px'}">CREAR</button>
      </section>
    </section>
  </article>
</template>

<script>
import Departaments from './../../vue/additionalData/departaments.js';
  export default {
    
    data(){
      return{
        isCreated:false,
        user: {
          name: '',
          lastName: '',
          cc: '',
          email: '',
          id: '',
          role: false,
          department:''
        },
        isInError: false,
        departamentos:Departaments.departaments,
        errorMessage:"",
      
      }
    },
    methods:{      
      selectFocused(){        
        document.getElementById("select1").style="color: black;"
      },

      selectBlur(){          
        if(!this.user.departmento){           
          document.getElementById("select1").style="color: black;"
        }
      },
      createAdministrator(){
        this.isCreated=true;  
        setTimeout(() => { this.isCreated=false; }, 200);
        const customActions={
            createAdmin: {headers:{"Authorization": 'Bearer '+localStorage.getItem('crypto')},method: 'POST'}                   
        };
        this.resource= this.$resource('administrators/users',{},customActions);
        this.resource.createAdmin({"user": {"id_card": this.user.cc, "card_company": this.user.id,"name": this.user.name,"last_name": this.user.lastName, "email": this.user.email, "department":this.user.department}})
        .then(function(data){
          this.errorMessage="";
          this.$router.push({ name: 'Admins' });
        }).catch(function(err){
          console.log(err.body);
          var errorlog=Object.keys(JSON.parse(err.bodyText).errors)[0];
          if (JSON.parse(err.bodyText).errors[errorlog][0]){
            if(JSON.parse(err.bodyText).errors[errorlog][0]=="has already been taken"){
              this.errorMessage="El número de cédula ya se encuentra registrado"             
            }else{
              this.errorMessage="Ha ocurrido un error en la creación, intentelo de nuevo"
            }
          }else{
            this.errorMessage="Ha ocurrido un error en la creación, intentelo de nuevo"
          }
        });
      },
      isComplete(){
        if(this.user.name!='' && this.user.lastName!='' && this.user.cc!='' && this.user.email!='' && !this.isInError && this.user.department){
          return true;
        }
        
      },
      checkMailAcepted(){

        if(!this.isMailAcepted){
            this.isInError=true;
        }
        else{
          this.isInError=false
        }
      },
    },
    created(){        
       
        
    },
    computed:{
      
      isMailAcepted(){

          var regex = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
          return regex.test(this.user.email) ? true : false;
      }
    },
   

  }
  
</script>


// WEBPACK FOOTER //
// src/components/pages/CreateAdmin.vue